import script from "./TypewriterText.vue?vue&type=script&setup=true&lang=js"
export * from "./TypewriterText.vue?vue&type=script&setup=true&lang=js"

import "./TypewriterText.vue?vue&type=style&index=0&id=54a45b8c&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a45b8c"]])

export default __exports__